import {
    ChangeDetectorRef,
    Component,
    NgZone,
    OnInit,
    ViewChild
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ApiUrls } from 'src/app/core/classes/ApiUrls';
import { CustomValidators } from 'src/app/shared/classes/CustomValidators';
import { Helper } from 'src/app/shared/classes/Helper';
import { HitApi } from 'src/app/shared/classes/HitApi';
import { Messages } from 'src/app/shared/classes/Messages';
import { ModalInjectedData } from 'src/app/shared/classes/ModalInjectedData';
import { Widget } from 'src/app/shared/classes/Widget';
import { AuthorizationType } from 'src/app/shared/enums/AuthorizationType';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { FilterType } from 'src/app/shared/enums/FilterType';
import { FormState } from 'src/app/shared/enums/FormState';
import { RequestType } from 'src/app/shared/enums/RequestType';
import { SupportedFormat } from 'src/app/shared/enums/SupportedFormat';
import { IFormField } from 'src/app/shared/interfaces/form-generator/IFormField';
import { IHitApi } from 'src/app/shared/interfaces/hit-api/IHitApi';
import { ConfigCacheService } from 'src/app/shared/services/cache/config-cache/config-cache.service';
import { HttpService } from 'src/app/shared/services/http/http-main/http.service';
import { ListHttpService } from 'src/app/shared/services/http/list-http/list-http.service';
import { ModalService } from 'src/app/shared/services/modal/modal-service/modal.service';
import { MultiStepFormService } from 'src/app/shared/services/modal/multi-step-form/multi-step-form.service';
import { NotificationsService } from 'src/app/shared/services/notifications/notifications.service';
import { UserDataCacheService } from 'src/app/shared/services/user-data-cache/user-data-cache.service';
import { ButtonColorType } from './../../../../enums/ButtonColorType';
import { ContentType } from './../../../../enums/ContentType';
import { IconType } from './../../../../enums/IconType';
import { IntegrationName } from './../../../../enums/IntegrationName';
import { IButtonGeneratorInput } from './../../../../interfaces/button-generator/IButtonGeneratorInput';
import { IFormGeneratorInput } from './../../../../interfaces/form-generator/IFormGeneratorInput';
import { IIcon } from './../../../../interfaces/icon-data/IIcon';
import { WhiteLabelingService } from './../../../../services/white-labeling/white-labeling.service';
import { IConfirmationModal } from 'src/app/shared/interfaces/modal/IConfirmationModal';

@Component({
    selector: 'app-create-report-third-step',
    templateUrl: './create-report-third-step.component.html',
    styleUrls: ['./create-report-third-step.component.sass']
})
export class CreateReportThirdStepComponent implements OnInit {
    @ViewChild('tabGroup') tabGroup;
    SAVE_DISABLE_MESSAGE = `Fill in recipient details under Download & Messaging to Save & Schedule reports`;
    Tab = Tab;
    IntegrationName = IntegrationName;
    initialSelection: IntegrationName[] = [];
    selectedTab = Tab.DOWNLOAD_AND_MESSAGING;
    selectedIntegrations: Map<
        IntegrationName,
        {
            iconData: IIcon;
            name: string;
            integrationData;
            integrated: boolean;
        }
    > = new Map();
    backButton: IButtonGeneratorInput = {
        buttonName: 'Back',
        buttonColorType: ButtonColorType.PRIMARY,
        buttonType: ButtonType.FLAT,
        function: () => {
            this.multiStepFormService.previousStep(this.modalInputData.modalId);
        }
    };
    downloadButton: IButtonGeneratorInput = {
        buttonName: 'Download',
        buttonColorType: ButtonColorType.PRIMARY,
        buttonType: ButtonType.FLAT,
        buttonIcon: {
            type: IconType.FONTAWSOME,
            class: 'fas fa-download'
        },
        showLoader: true,
        function: (buttonRef) => {
            this.downloadReport(buttonRef);
        },
        disable: this.isDownloadButtonDisable
    };
    sendButton: IButtonGeneratorInput = {
        buttonName: 'Send',
        buttonColorType: ButtonColorType.PRIMARY,
        buttonType: ButtonType.FLAT,
        showLoader: true,
        buttonIcon: {
            type: IconType.FONTAWSOME,
            class: 'fas fa-envelope'
        },
        function: (buttonRef) => {
            this.sendReport(buttonRef);
        }
    };
    saveScheduleButton: IButtonGeneratorInput = {
        buttonName: 'Save & Schedule',
        buttonColorType: ButtonColorType.PRIMARY,
        buttonType: ButtonType.FLAT,
        hoverText: !this.enableSaveAndSchedule()
            ? this.SAVE_DISABLE_MESSAGE
            : null,
        buttonIcon: {
            type: IconType.FONTAWSOME,
            class: 'fas fa-chevron-right'
        },
        function: () => {
            this.enableSaveAndSchedule()
                ? this.switchToSave(this.tabGroup)
                : null;
        }
    };
    lastSaveScheduleButton: IButtonGeneratorInput = {
        buttonName: 'Save & Schedule',
        buttonColorType: ButtonColorType.PRIMARY,
        buttonType: ButtonType.FLAT,
        showLoader: true,
        hoverText: !this.enableSaveAndSchedule()
            ? this.SAVE_DISABLE_MESSAGE
            : null,
        buttonIcon: {
            type: IconType.FONTAWSOME,
            class: 'fas fa-clock'
        },
        function: (buttonRef) => {
            this.saveReport(buttonRef);
        }
    };

    availableSupportedFormats: Set<SupportedFormat> = new Set();

    downloadReportFormGenInput: IFormGeneratorInput = null;
    downloadReportFormGroup: FormGroup = null;
    sendEmailFormGenInput: IFormGeneratorInput = null;
    sendEmailFormGroup: FormGroup = null;
    slackFormGenInput: IFormGeneratorInput = null;
    slackFormGroup: FormGroup = null;
    // gmailFormGenInput: IFormGeneratorInput = null;
    // gmailFormGroup: FormGroup = null;
    // o365FormGenInput: IFormGeneratorInput = null;
    // o365FormGroup: FormGroup = null;

    reportFrequencyFormGenInput: IFormGeneratorInput = null;
    reportFrequencyFormGroup: FormGroup = null;

    receiveReportFormGenInput: IFormGeneratorInput = null;
    receiveReportFormGroup: FormGroup = null;

    billingDayFormGenInput: IFormGeneratorInput = null;
    billingDayFormGroup: FormGroup = null;

    sendLoader = false;
    downloadLoader = false;
    saveLoader = false;

    getIntegrationData = null;

    edit = false;
    reportData = null;
    sendingMechanism = null;
    reportFilters = null;
    widgetRef: Widget = null;
    defaultEmails;
    defaultCopyEmails;
    defaultBcopyEmails;
    timeFormGenInput: IFormGeneratorInput = null;
    timeFormGroup: FormGroup = null;
    timeZoneValue: string;
    timeRange: string;
    domain: string;
    domainIdSet = new Set<string>([
        'Algonomy',
        'singapore',
        'dbtestdp',
        'schedulerdkron'
    ]);
    constructor(
        public modalInputData: ModalInjectedData,
        public multiStepFormService: MultiStepFormService,
        private modalService: ModalService,
        private whiteLabelingService: WhiteLabelingService,
        private notificationsService: NotificationsService,
        private httpService: HttpService,
        private ngZone: NgZone,
        private configCache: ConfigCacheService,
        private userDataCache: UserDataCacheService,
        private listHttpService: ListHttpService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.widgetRef = this.modalInputData.data.widgetRef;
        const generalConfig = this.configCache.getGeneralConfig(
            this.userDataCache.emailId,
            this.configCache.viewId
        );
        this.domain = this.userDataCache.domainId;
        if (generalConfig) {
            this.defaultEmails = generalConfig.primaryEmail?.emails
                ? generalConfig.primaryEmail.emails
                : [];
            this.defaultCopyEmails = generalConfig.primaryEmail?.copyEmails
                ? generalConfig.primaryEmail.copyEmails
                : [];
            this.defaultBcopyEmails = generalConfig.primaryEmail?.bcopyEmails
                ? generalConfig.primaryEmail.bcopyEmails
                : [];
        }
        if (
            this.modalInputData &&
            this.modalInputData.data &&
            this.modalInputData.data['stepData']
        ) {
            this.reportData = this.modalInputData.data['stepData'];
            this.reportFilters = this.reportData['reportFilters'];
            this.sendingMechanism = this.reportFilters['sendingMechanism'];
            if (this.domainIdSet.has(this.domain)) {
                this.timeRange = this.reportFilters['timeLowerRange'] + '-' + this.reportFilters['timeUpperRange'];
                this.timeZoneValue = this.reportFilters['selectedTimeZone'];
            }
            this.edit = true;
            if (this.sendingMechanism['sendViaEmail']) {
                if (this.isReadAccess) {
                    this.initialSelection.push(IntegrationName.DOWNLOAD_REPORT)
                } else {
                    this.initialSelection.push(IntegrationName.EMAIL);
                }
            }
            if (this.sendingMechanism['o365IntegrationId']) {
                this.initialSelection.push(IntegrationName.O365);
            }
            if (this.sendingMechanism['gmailIntegrationId']) {
                this.initialSelection.push(IntegrationName.GMAIL);
            }
            if (
                (this.sendingMechanism['slackUsersIds'] &&
                    this.sendingMechanism['slackUsersIds'].length) ||
                (this.sendingMechanism['slackChannelIds'] &&
                    this.sendingMechanism['slackChannelIds'].length)
            ) {
                this.initialSelection.push(IntegrationName.SLACK);
            }
        } else {
            this.initialSelection = [IntegrationName.DOWNLOAD_REPORT];
        }
        if (
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .has(2) &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(2)['supportedFormats']
        ) {
            this.availableSupportedFormats = this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(2)['supportedFormats'];
        }

        // Report formats
        const formats = [];
        if (this.availableSupportedFormats.has(SupportedFormat.EXCEL)) {
            formats.push({
                label: 'Excel',
                id: 'excel'
            });
        }

        if (this.availableSupportedFormats.has(SupportedFormat.CSV)) {
            formats.push({
                label: 'CSV',
                id: 'csv'
            });
        }

        if (this.availableSupportedFormats.has(SupportedFormat.PDF)) {
            formats.push({
                label: 'PDF',
                id: 'pdf'
            });
        }
        if (!formats.length) {
            formats.push({
                label: 'EXCEL',
                id: 'excel'
            });
        }

        const getReportFormatValue = () => {
            if (formats && formats.length) {
                //Checks if stepData has reportFormat saved and finds it in format Array
                if (this.reportData && this.reportData['reportType']) {
                    const reportFormat = formats.find((report) =>
                        this.reportData['reportType'].includes(report['label'])
                    );
                    if (reportFormat) {
                        return reportFormat['id'];
                    } else {
                        return formats[0].id;
                    }
                } else {
                    return formats[0].id;
                }
            } else {
                return null;
            }
        };
        // Download Report Form Gen Input
        this.downloadReportFormGenInput = {
            formName: '',
            state: FormState.CREATE,
            submitButton: null,
            fields: [
                {
                    name: 'reportFormat',
                    label: 'Report Format',
                    placeholder: 'Report Format',
                    fieldType: FilterType.RADIO,
                    value: getReportFormatValue(),
                    listData: formats,
                    required: true,
                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Report format is required'
                        }
                    ]
                }
            ]
        };

        // Send Email Form Gen Input
        let subject =
            this.whiteLabelingService.whiteLableData.reportSubject.replace(
                /{{reportName}}/g,
                this.multiStepFormService.stepData
                    .get(this.modalInputData.modalId)
                    .get(1)['reportName']
            );
        subject = subject.replace(
            /{{companyName}}/g,
            this.whiteLabelingService.whiteLableData.companyName
        );
        const reportContent =
            this.whiteLabelingService.whiteLableData.reportContent.replace(
                /{{companyName}}/g,
                this.whiteLabelingService.whiteLableData.companyName
            );
        let emailValue;
        if (
            this.sendingMechanism &&
            this.sendingMechanism['emailRequest'] &&
            this.sendingMechanism['emailRequest']['emailTo'] &&
            this.sendingMechanism['emailRequest']['emailTo'].length
        ) {
            emailValue = Helper.cloneDeep(
                this.sendingMechanism['emailRequest']['emailTo']
            );
        }
        this.sendEmailFormGenInput = {
            formName: '',
            submitButton: null,
            state: FormState.CREATE,
            fields: [
                {
                    name: 'emailTo',
                    fieldType: FilterType.MATCHIPLIST,
                    type: 'email',
                    value:
                        this.edit && emailValue
                            ? emailValue
                            : this.defaultEmails
                            ? this.defaultEmails
                            : [],
                    label: 'To',
                    placeholder: 'example@domain.com',
                    required: true,
                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Atleast one recipients is required'
                        },
                        {
                            validator: CustomValidators.matChipAllowEmail,
                            errorMessage: 'Enter valid email'
                        }
                    ],
                    disabled: this.isWriteAccess
                },
                {
                    name: 'subject',
                    fieldType: FilterType.TEXT,
                    label: 'Subject',
                    placeholder: 'Subject',
                    value:
                        this.edit &&
                        this.sendingMechanism &&
                        this.sendingMechanism['emailRequest'] &&
                        this.sendingMechanism['emailRequest']['subject'] &&
                        this.sendingMechanism['emailRequest']['subject'].length
                            ? this.sendingMechanism['emailRequest']['subject']
                            : subject,
                    required: true,
                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Subject is required'
                        }
                    ]
                },
                {
                    name: 'copyTo',
                    fieldType: FilterType.MATCHIPLIST,
                    type: 'email',
                    label: 'CC',
                    placeholder: 'example@domain.com',
                    required:false,
                    value:
                        this.edit &&
                        this.sendingMechanism &&
                        this.sendingMechanism['emailRequest'] &&
                        this.sendingMechanism['emailRequest']['copyTo'] &&
                        this.sendingMechanism['emailRequest']['copyTo'].length
                            ? this.sendingMechanism['emailRequest']['copyTo']
                            : this.defaultCopyEmails
                            ? this.defaultCopyEmails
                            : [],
                    validations: [
                        {
                            validator: CustomValidators.matChipAllowEmail,
                            errorMessage: 'Enter valid email'
                        }
                    ],
                    disabled: this.isWriteAccess
                },
                {
                    name: 'bcc',
                    fieldType: FilterType.MATCHIPLIST,
                    type: 'email',
                    label: 'BCC',
                    placeholder: 'example@domain.com',
                    required:false,
                    value:
                        this.edit &&
                        this.sendingMechanism &&
                        this.sendingMechanism['emailRequest'] &&
                        this.sendingMechanism['emailRequest']['bcc'] &&
                        this.sendingMechanism['emailRequest']['bcc'].length
                            ? this.sendingMechanism['emailRequest']['bcc']
                            : this.defaultBcopyEmails
                            ? this.defaultBcopyEmails
                            : [],
                    validations: [
                        {
                            validator: CustomValidators.matChipAllowEmail,
                            errorMessage: 'Enter valid email'
                        }
                    ],
                    disabled: this.isWriteAccess
                },
                {
                    name: 'emailBody',
                    fieldType: FilterType.WYSIWYG_EDITOR,
                    label: 'Email Content',
                    placeholder: 'Email Content',
                    required: true,
                    value:
                        this.edit &&
                        this.sendingMechanism &&
                        this.sendingMechanism['emailRequest'] &&
                        this.sendingMechanism['emailRequest']['emailBody'] &&
                        this.sendingMechanism['emailRequest']['emailBody']
                            .length
                            ? this.sendingMechanism['emailRequest']['emailBody']
                            : reportContent,
                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Email content is required'
                        }
                    ]
                }
            ]
        };

        // Slack Form Gen Input
        this.slackFormGenInput = {
            formName: '',
            state: FormState.CREATE,
            submitButton: null,
            fields: [
                {
                    label: 'Users',
                    name: 'users',
                    fieldType: FilterType.DROPDOWN_MULTIPLE,
                    placeholder: 'Select Users',
                    required: true,
                    value:
                        this.edit &&
                        this.reportData['slackUsersIds'] &&
                        this.reportData['slackUsersIds'].length
                            ? this.reportData['slackUsersIds']
                            : [],
                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Select atleast one user'
                        }
                    ],
                    apiInfo: {
                        requestType: RequestType.GET,
                        customInput: null,
                        host: null,
                        apiRouteSuffix: ApiUrls.SLACK_LIST_USERS,
                        authorization: AuthorizationType.BEARER_TOKEN
                    },
                    showKey: 'label',
                    getKey: 'id',
                    responseValueKey: 'usersInfo'
                },
                {
                    label: 'Channels',
                    name: 'channels',
                    fieldType: FilterType.DROPDOWN_MULTIPLE,
                    placeholder: 'Select Channels',
                    validations: null,
                    value:
                        this.edit &&
                        this.reportData['slackChannelIds'] &&
                        this.reportData['slackChannelIds'].length
                            ? this.reportData['slackChannelIds']
                            : [],
                    apiInfo: {
                        requestType: RequestType.GET,
                        customInput: null,
                        host: null,
                        apiRouteSuffix: ApiUrls.SLACK_LIST_CHANNELS,
                        authorization: AuthorizationType.BEARER_TOKEN
                    },
                    showKey: 'label',
                    getKey: 'id',
                    responseValueKey: 'channalsInfo'
                }
            ]
        };

        // Report Frequency Form Gen Input
        this.reportFrequencyFormGenInput = {
            formName: '',
            state: FormState.CREATE,
            submitButton: null,
            fields: [
                {
                    fieldType: FilterType.RADIO,
                    name: 'reportFrequency',
                    label: 'Report Frequency',
                    placeholder: 'Report Frequency',
                    required: true,
                    value:
                        this.edit &&
                        this.reportFilters &&
                        this.reportFilters['reportTimespan']
                            ? this.reportFilters['reportTimespan'].toLowerCase()
                            : 'monthly',
                    listData: [
                        {
                            id: 'monthly',
                            label: 'Monthly'
                        },
                        {
                            id: 'daily',
                            label: 'Daily'
                        },
                        {
                            id: 'weekly',
                            label: 'Weekly'
                        },
                        {
                            id: 'custom',
                            label: 'Custom'
                        }
                    ],
                    prefixIcon: {
                        hoverText: 'Click here for more info',
                        iconData: {
                            type: IconType.MATICON,
                            class: 'help'
                        },
                        function: (field: IFormField, formGroup: FormGroup) => {
                            this.modalService.openInfoModal({
                                infoHeading:
                                    'Select the period for which report is to be scheduled',
                                content: [
                                    {
                                        type: 'UNORDERED_LIST',
                                        data: [
                                            `<b>Monthly:</b> Schedule to automatically receive reports based on your last month’s data.<br>Example: If you want a report to be scheduled for a month, i.e. from 1st to 31st of the month then use this.`,
                                            `<b>Daily:</b> Schedule to automatically receive reports based on your last day’s data.<br>Example: If you want a report to be scheduled on daily bases, i.e. you want a 24 hours report then use this.`,
                                            `<b>Weekly:</b> Schedule to automatically receive reports based on your last week’s data.<br>Example: If you want a report to be scheduled for a week, i.e. from Monday to Tuesday, then use this.`,
                                            `<b>Custom:</b> Schedule to automatically receive reports as per your billing cycle.<br>Example: If you want a report to be scheduled as per your billing cycle, i.e. if your billing cycle is from 7th of a month to 6th of another month, then use this to get a report for that specified billing cycle.`
                                        ]
                                    }
                                ]
                            });
                        }
                    }
                }
            ]
        };
        if (this.domainIdSet.has(this.domain)) {
            this.timeFormGenInput = {
                formName: 'Time',
                submitButton: null,
                state: FormState.CREATE,
                fields: [
                    {
                        name: 'timeRange',
                        fieldType: FilterType.DROPDOWN_SINGLE,
                        label: 'Time Range',
                        placeholder: '',
                        value: this.timeRange ? this.timeRange : '',
                        apiInfo: this.listHttpService.timeRange,
                        required: true,
                        validations: [
                            {
                                validator: CustomValidators.required,
                                errorMessage: 'is required'
                            }
                        ],
                        fieldStyle: {
                            'min-width': '20%'
                        },
                        prefixIcon: {
                            hoverText: 'Only 60 reporting rules can be scheduled in the same time slot. Hence, if the limit is exceeded, please choose another time slot from the ones available.',
                            iconData: {
                                type: IconType.MATICON,
                                class: 'info',
                                extraClass: 'margin-class'
                            }
                        }
                    },
                    {
                        name: 'timeZone',
                        fieldType: FilterType.DROPDOWN_SINGLE,
                        label: 'Time Zone',
                        placeholder: 'Select Timezone',
                        value: this.timeZoneValue ? this.timeZoneValue : 'UTC',
                        apiInfo: this.listHttpService.timeZoneApiInfo,
                        responseValueKey: 'dataList',
                        required: true,
                        validations: [
                            {
                                validator: CustomValidators.required,
                                errorMessage: 'Time Zone is required'
                            }
                        ],
                        fieldStyle: {
                            width: '28%',
                            'margin-left': '3%'
                        }
                    }
                ]
            };
        }
        // Receive report form gen input
        this.receiveReportFormGenInput = {
            formName: '',
            state: FormState.CREATE,
            submitButton: null,
            fields: [
                {
                    name: 'weekDay',
                    fieldType: FilterType.DROPDOWN_SINGLE,
                    label: 'Receive Report On',
                    placeholder: 'Receive Report On',
                    required: true,
                    value:
                        this.edit &&
                        this.reportFilters &&
                        this.reportFilters['dayOfWeek']
                            ? this.reportFilters['dayOfWeek']
                            : 'MON',

                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Week day is required'
                        }
                    ],
                    listData: [
                        {
                            id: 'MON',
                            label: 'Monday'
                        },
                        {
                            id: 'TUE',
                            label: 'Tuesday'
                        },
                        {
                            id: 'WED',
                            label: 'Wednesday'
                        },
                        {
                            id: 'THU',
                            label: 'Thursday'
                        },
                        {
                            id: 'FRI',
                            label: 'Friday'
                        },
                        {
                            id: 'SAT',
                            label: 'Saturday'
                        },
                        {
                            id: 'SUN',
                            label: 'Sunday'
                        }
                    ]
                }
            ]
        };

        const billingDays = Array(31)
            .fill(1)
            .map((val, index) => {
                return {
                    id: `${index + 1}`,
                    label: `${index + 1}`
                };
            });

        // Billing day form gen input
        this.billingDayFormGenInput = {
            formName: '',
            state: FormState.CREATE,
            submitButton: null,
            fields: [
                {
                    name: 'billingDay',
                    fieldType: FilterType.DROPDOWN_SINGLE,
                    label: 'Billing Day',
                    placeholder: 'Billing Day',
                    required: true,
                    value:
                        this.edit &&
                        this.reportFilters &&
                        this.reportFilters['billingDay']
                            ? `${this.reportFilters['billingDay']}`.toLowerCase()
                            : '1',
                    validations: [
                        {
                            validator: CustomValidators.required,
                            errorMessage: 'Week day is required'
                        }
                    ],
                    listData: billingDays
                }
            ]
        };
        if (this.domainIdSet.has(this.domain)) {
            this.receiveReportFormGenInput.fields.push(...this.timeFormGenInput.fields);
            this.billingDayFormGenInput.fields.push(...this.timeFormGenInput.fields);
        }
        /**
         * To show confirmation Modal while creating Report 
         * if user Select 'Consolidated Cost by Accounts (AWS, Multi-Accounts)' widget.
         */
        if (
            this.multiStepFormService &&
            this.multiStepFormService.stepData &&
            this.multiStepFormService.stepData.get(
                this.modalInputData.modalId
            ) &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1) &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1)['widgetsSelected'] &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1)
                ['widgetsSelected'].includes(
                    'ab59b2d8-2dbb-4828-a102-01b10fd23aff'
                )
        ) {
            const modalData: IConfirmationModal = {
                modalName: 'Report Confirmation',
                confirmationMessage: `The report for the 'Consolidated Cost by Accounts (AWS, Multi-Accounts)' widget will be sent to your email. Once you confirm, you'll be able to view the data from the other widgets in the downloaded file`,
                buttonText: 'Confirm',
                buttonColorType: ButtonColorType.PRIMARY,
                hideCancelButton: true,
                function: (modalId: Symbol) => {
                    this.modalService.closeModal(null, modalId);
                },
                modalWidthVw: 45,
                modalAutoHeight: true,
            };
            this.modalService.openConfirmationModal(modalData);
        }
    }
    /**
     * To disable Download Report Button, 
     * while Creating Report if user Selected only 
     * 'Consolidated Cost by Accounts (AWS, Multi-Accounts)' widget.
    */
    get isDownloadButtonDisable() {
        if (
            this.multiStepFormService &&
            this.multiStepFormService.stepData &&
            this.multiStepFormService.stepData.get(
                this.modalInputData.modalId
            ) &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1) &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1)['widgetsSelected'] &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1)
                ['widgetsSelected'].includes(
                    'ab59b2d8-2dbb-4828-a102-01b10fd23aff'
                ) &&
            this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1)['widgetsSelected'].length === 1
        ) {
            return true;
        } else {
            return false;
        }
    }

    get isReadAccess() {
        const currentUser = this.userDataCache.emailId;
        if (currentUser === this.reportData?.createdBy?.email) {
            return false;
        } else {
            let isReadAccessNewStatus = false;
            this.reportData?.userReportWithAccessControl?.map((user) => {
                const userEmail = user?.userInfo?.email;
                if (
                    currentUser === userEmail &&
                    user?.reportAccessControlFlag === 'READ'
                ) {
                    isReadAccessNewStatus = true;
                }
            });
            return isReadAccessNewStatus;
        }
    }

    get isWriteAccess() {
        const currentUser = this.userDataCache.emailId;
        if (currentUser === this.reportData?.createdBy?.email) {
            return false;
        } else {
            let isWriteAccess = false;
            this.reportData?.userReportWithAccessControl?.map((user) => {
                const userEmail = user?.userInfo?.email;
                if (
                    currentUser === userEmail &&
                    user?.reportAccessControlFlag === 'WRITE'
                ) {
                    isWriteAccess = true;
                }
            });
            return isWriteAccess;
        }
    }

    changeTabs(tab) {
        this.selectedTab = tab ? tab : Tab.SAVE_AND_SCHEDULE;
    }

    integrationsChanged(integrations) {
        this.selectedIntegrations = integrations;
    }

    enableSaveAndSchedule(): boolean {
        if (
            (this.sendEmailFormGroup && this.sendEmailFormGroup.valid) ||
            (this.slackFormGroup && this.slackFormGroup.valid)
        ) {
            if (this.selectedIntegrations.size === 1) {
                if (
                    this.selectedIntegrations.has(
                        IntegrationName.DOWNLOAD_REPORT
                    )
                ) {
                    return false;
                } else {
                    return true;
                }
            } else if (this.selectedIntegrations.size === 0) {
                return false;
            } else {
                return true;
            }
        }

        return false;
    }

    switchToSave(tabGroup: MatTabGroup) {
        this.selectedTab = Tab.SAVE_AND_SCHEDULE;
        tabGroup.selectedIndex = 1;
    }

    downloadReport(buttonRef) {
        if (this.downloadLoader && buttonRef.loader) {
            return;
        }
        if (this.downloadReportFormGroup.invalid) {
            return;
        }
        buttonRef.loader = true;
        this.downloadLoader = true;
        const downloadReportInput = this.getBasicInputs();
        const contentType: ContentType =
            downloadReportInput.reportType === 'REPORT_EXCEL'
                ? ContentType.EXCEL
                : downloadReportInput.reportType === 'REPORT_CSV'
                ? ContentType.ZIP
                : downloadReportInput.reportType === 'REPORT_PDF'
                ? ContentType.PDF
                : null;

        let apiArgs: IHitApi = null;

        if (
            this.widgetRef &&
            this.widgetRef.widgetData.widgetInfo.additionalApisForWidget[
                'download'
            ]
        ) {
            apiArgs = Helper.generateHitApiConfig(
                this.widgetRef.widgetData.widgetInfo.additionalApisForWidget[
                    'download'
                ]
            );
        } else {
            apiArgs = Helper.generateHitApiConfig(
                this.listHttpService.downloadReportApi
            );

            apiArgs.config.downloadable = true;
        }

        apiArgs.initiatorWidgetId = apiArgs.uniqueIdentity as symbol;
        apiArgs.partialBindFunction = (data) => {
            if (data && data['presignedUrl']) {
                Helper.downloadReport(
                    data['presignedUrl'],
                    downloadReportInput.reportType.toLowerCase(),
                    downloadReportInput.reportName,
                    this.httpService,
                    this.ngZone
                );
            }
        };

        apiArgs.input = downloadReportInput;
        apiArgs.streamCloseCallback = () => {
            this.downloadLoader = false;
            buttonRef.loader = false;
            this.cdr.detectChanges();
        };
        apiArgs.function = (response) => {
            Helper.saveAsBlob(
                response,
                contentType,
                downloadReportInput.reportName
            );
        };
        apiArgs.errorFunction = (error) => {
            this.notificationsService.showSnackBar(
                error && error.error && error.error.message
                    ? error.error.message
                    : 'Error downloading report',
                true
            );
            this.downloadLoader = false;
        };
        apiArgs.endFunction = () => {
            this.downloadLoader = false;
            buttonRef.loader = false;
            this.cdr.detectChanges();
        };

        if (apiArgs.requestType === RequestType.RSOCKET_STREAM) {
            new HitApi(apiArgs, this.httpService, this.ngZone).hitStreamApi();
        } else {
            new HitApi(apiArgs, this.httpService, this.ngZone).hitApi();
        }
    }

    sendReport(buttonRef) {
        if (this.sendLoader && buttonRef.loader) {
            return;
        }
        if (
            this.selectedIntegrations.has(IntegrationName.EMAIL) ||
            this.selectedIntegrations.has(IntegrationName.O365) ||
            this.selectedIntegrations.has(IntegrationName.GMAIL)
        ) {
            Helper.markAllFieldAsTouched(this.sendEmailFormGroup);
            if (this.sendEmailFormGroup.invalid) {
                this.notificationsService.showSnackBar(
                    Messages.FILL_ALL_FIELDS,
                    true
                );
                return;
            }
        }

        let users = [];
        let channels = [];

        if (this.selectedIntegrations.has(IntegrationName.SLACK)) {
            users = this.slackFormGroup.value['users'];
            channels = this.slackFormGroup.value['channels'];

            if (
                !users ||
                (users && !users.length) ||
                !channels ||
                (channels && !channels.length)
            ) {
                this.notificationsService.showSnackBar(
                    `Please select atleast one channel and/or user`,
                    true
                );
                return;
            }
        }
        buttonRef.loader = true;
        this.sendLoader = true;
        const sendingMechanism = {
            sendViaEmail: this.selectedIntegrations.has(IntegrationName.EMAIL)
        };
        if (
            this.selectedIntegrations.has(IntegrationName.EMAIL) ||
            this.selectedIntegrations.has(IntegrationName.O365) ||
            this.selectedIntegrations.has(IntegrationName.GMAIL)
        ) {
            sendingMechanism['emailRequest'] = this.sendEmailFormGroup.value;
        }
        if (this.selectedIntegrations.has(IntegrationName.O365)) {
            sendingMechanism['o365IntegrationId'] =
                this.selectedIntegrations.get(
                    IntegrationName.O365
                ).integrationData['id'];
        }
        if (this.selectedIntegrations.has(IntegrationName.GMAIL)) {
            sendingMechanism['gmailIntegrationId'] =
                this.selectedIntegrations.get(
                    IntegrationName.GMAIL
                ).integrationData['id'];
        }
        if (this.selectedIntegrations.has(IntegrationName.SLACK)) {
            sendingMechanism['slackUsersIds'] = users;
            sendingMechanism['slackChannelIds'] = channels;
        }
        const sendReqInput = this.getBasicInputs();
        sendReqInput['reportFilters'] = {
            sendingMechanism
        };

        const apiArgs: IHitApi = {
            url: ApiUrls.SEND_REPORT,
            input: sendReqInput,
            requestType: RequestType.POST,
            uniqueIdentity: Symbol(),
            config: {
                authorization: AuthorizationType.BEARER_TOKEN
            },
            function: (response) => {
                this.sendLoader = false;
                buttonRef.loader = false;
                this.notificationsService.showSnackBar(
                    'Report sent successfully'
                );
            },
            errorFunction: (error) => {
                this.sendLoader = false;
                buttonRef.loader = false;
                Helper.showErrorMessage(
                    this.notificationsService,
                    error,
                    'Error sending report'
                );
            },
            endFunction: () => {
                buttonRef.loader = false;
                this.sendLoader = false;
            }
        };

        new HitApi(apiArgs, this.httpService, this.ngZone).hitApi();
    }

    saveReport(buttonRef) {
        if (this.saveLoader && buttonRef.loader) {
            return;
        }
        if (
            this.selectedIntegrations.has(IntegrationName.EMAIL) ||
            this.selectedIntegrations.has(IntegrationName.O365) ||
            this.selectedIntegrations.has(IntegrationName.GMAIL)
        ) {
            Helper.markAllFieldAsTouched(this.sendEmailFormGroup);
            if (this.sendEmailFormGroup.invalid) {
                this.notificationsService.showSnackBar(
                    Messages.FILL_ALL_FIELDS,
                    true
                );
                return;
            }
        }

        let users = [];
        let channels = [];

        if (this.selectedIntegrations.has(IntegrationName.SLACK)) {
            users = this.slackFormGroup.value['users'];
            channels = this.slackFormGroup.value['channels'];

            if (
                !users ||
                (users && !users.length) ||
                !channels ||
                (channels && !channels.length)
            ) {
                this.notificationsService.showSnackBar(
                    `Please select atleast one channel and/or user`,
                    true
                );
                return;
            }
        }

        const freq = this.reportFrequencyFormGroup.get('reportFrequency').value;
        const reportTimespan = freq.toUpperCase();
        let dayOfWeek = null;
        let billingDay = null;
        let timeLowerRange = null;
        let timeUpperRange = null;
        let selectedTimeZone = null;
        if (freq === 'weekly') {
            Helper.markAllFieldAsTouched(this.receiveReportFormGroup);
            if (this.receiveReportFormGroup.invalid) {
                this.notificationsService.showSnackBar(
                    Messages.FILL_ALL_FIELDS,
                    true
                );
                return;
            }
            dayOfWeek = this.receiveReportFormGroup.get('weekDay').value;
            if (this.domainIdSet.has(this.domain)) {
                timeLowerRange = this.receiveReportFormGroup.get('timeRange').value.split('-')[0];
                timeUpperRange = this.receiveReportFormGroup.get('timeRange').value.split('-')[1];
                selectedTimeZone = this.receiveReportFormGroup.get('timeZone').value;
            }
        } else if (freq === 'custom') {
            Helper.markAllFieldAsTouched(this.billingDayFormGroup);
            if (this.billingDayFormGroup.invalid) {
                this.notificationsService.showSnackBar(
                    Messages.FILL_ALL_FIELDS,
                    true
                );
                return;
            }
            billingDay = this.billingDayFormGroup.get('billingDay').value;
            if (this.domainIdSet.has(this.domain)) {
                timeLowerRange = this.billingDayFormGroup.get('timeRange').value.split('-')[0];
                timeUpperRange = this.billingDayFormGroup.get('timeRange').value.split('-')[1];
                selectedTimeZone = this.billingDayFormGroup.get('timeZone').value;
            }
        } else if (freq === 'monthly' && this.domainIdSet.has(this.domain)) {
            Helper.markAllFieldAsTouched(this.timeFormGroup);
            if (this.timeFormGroup.invalid) {
                this.notificationsService.showSnackBar(
                    Messages.FILL_ALL_FIELDS,
                    true
                );
                return;
            }
            timeLowerRange = this.timeFormGroup
                .get('timeRange')
                .value.split('-')[0];
            timeUpperRange = this.timeFormGroup
                .get('timeRange')
                .value.split('-')[1];
            selectedTimeZone = this.timeFormGroup.get('timeZone').value;
        } else if (freq === 'daily' && this.domainIdSet.has(this.domain)) {
            Helper.markAllFieldAsTouched(this.timeFormGroup);
            if (this.timeFormGroup.invalid) {
                this.notificationsService.showSnackBar(
                    Messages.FILL_ALL_FIELDS,
                    true
                );
                return;
            }
            timeLowerRange = this.timeFormGroup
                .get('timeRange')
                .value.split('-')[0];
            timeUpperRange = this.timeFormGroup
                .get('timeRange')
                .value.split('-')[1];
            selectedTimeZone = this.timeFormGroup.get('timeZone').value;
        }
        const sendingMechanism = {
            sendViaEmail: this.selectedIntegrations.has(IntegrationName.EMAIL)
        };
        if (
            this.selectedIntegrations.has(IntegrationName.EMAIL) ||
            this.selectedIntegrations.has(IntegrationName.O365) ||
            this.selectedIntegrations.has(IntegrationName.GMAIL)
        ) {
            if (this.isWriteAccess) {
                sendingMechanism['emailRequest'] =
                    this.sendEmailFormGroup.getRawValue();
            } else {
                sendingMechanism['emailRequest'] =
                    this.sendEmailFormGroup.value;
            }
        }
        if (this.selectedIntegrations.has(IntegrationName.O365)) {
            sendingMechanism['o365IntegrationId'] =
                this.selectedIntegrations.get(
                    IntegrationName.O365
                ).integrationData['id'];
        }
        if (this.selectedIntegrations.has(IntegrationName.GMAIL)) {
            sendingMechanism['gmailIntegrationId'] =
                this.selectedIntegrations.get(
                    IntegrationName.GMAIL
                ).integrationData['id'];
        }
        if (this.selectedIntegrations.has(IntegrationName.SLACK)) {
            sendingMechanism['slackUsersIds'] = users;
            sendingMechanism['slackChannelIds'] = channels;
        }
        const saveReqInput = this.getBasicInputs();
        let requestInput: RequestInput = {
            sendingMechanism,
            reportTimespan,
            dayOfWeek,
            billingDay
        };
        if (this.domainIdSet.has(this.domain)) {
            const timeRange = timeLowerRange + '-' + timeUpperRange;
            requestInput = {
                ...requestInput,
                timeLowerRange,
                timeUpperRange,
                selectedTimeZone,
                timeRange
            };
        }
        saveReqInput['reportFilters'] = requestInput;

        const createArgs: IHitApi = {
            url: ApiUrls.REPORT_ENDPOINT,
            uniqueIdentity: Symbol(),
            requestType: RequestType.POST,
            input: null,
            function: null,
            config: {
                authorization: AuthorizationType.BEARER_TOKEN
            }
        };
        const updateArgs: IHitApi = {
            url: ApiUrls.REPORT_ENDPOINT + '/{report-id}',
            uniqueIdentity: Symbol(),
            requestType: RequestType.PATCH,
            input: null,
            function: null,
            config: {
                authorization: AuthorizationType.BEARER_TOKEN
            }
        };
        if (this.edit) {
            updateArgs.intactUrl = updateArgs.url;
            updateArgs.url = updateArgs.url.replace(
                '{report-id}',
                this.reportData['id']
            );
        }

        createArgs.input = saveReqInput;
        if (!this.edit) {
            const currentUser = `${this.userDataCache.firstName} ${
                this.userDataCache.lastName ? this.userDataCache.lastName : ''
            }`.trim();
            createArgs.input['userNameWithWidgetsIds'] = {
            [currentUser]: this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .get(1)['widgetsSelected']};
            createArgs.input['userReportWithAccessControl'] = null;
        }
        updateArgs.input = saveReqInput;

        createArgs.function = (response) => {
            this.saveLoader = false;
            buttonRef.loader = false;
            this.notificationsService.showSnackBar(
                'Report created successfully'
            );
            if (this.widgetRef) {
                this.widgetRef.refreshWidget();
            }
            this.modalService.closeModal(null, this.modalInputData.modalId);
        };
        updateArgs.function = (response) => {
            this.saveLoader = false;
            buttonRef.loader = false;
            this.notificationsService.showSnackBar(
                'Report updated successfully'
            );
            if (this.widgetRef) {
                this.widgetRef.refreshWidget();
            }
            this.modalService.closeModal(null, this.modalInputData.modalId);
        };
        createArgs.errorFunction = (error) => {
            this.saveLoader = false;
            buttonRef.loader = false;
            this.notificationsService.showSnackBar(
                error && error.error && error.error.message
                    ? error.error.message
                    : 'Error creating report',
                true
            );
        };
        updateArgs.errorFunction = (error) => {
            this.saveLoader = false;
            buttonRef.loader = false;
            this.notificationsService.showSnackBar(
                error && error.error && error.error.message
                    ? error.error.message
                    : 'Error updating report',
                true
            );
        };

        new HitApi(
            !this.edit ? createArgs : updateArgs,
            this.httpService,
            this.ngZone
        ).hitApi();
    }

    getBasicInputs() {
        const step1Data = this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .get(1);
        const step2Data = this.multiStepFormService.stepData
            .get(this.modalInputData.modalId)
            .get(2);
        const reportInput = {
            reportName: step1Data['reportName'],
            widgetIds: step1Data['widgetsSelected'],
            reportType:
                `REPORT_` +
                `${
                    this.downloadReportFormGroup.get('reportFormat').value
                }`.toUpperCase(),
            widgetFilters: Helper.mapToObj(step2Data['widgetFilters'])
        };
        if (this.edit) {
            const currentUser = `${this.userDataCache.firstName} ${
                this.userDataCache.lastName ? this.userDataCache.lastName : ''
            }`;
            const widgetsSelected = this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(1)['widgetsSelected'];
            const userNameWithWidgetsIds: any[] =
                this.multiStepFormService.stepData
                    .get(this.modalInputData.modalId)
                    .has(3)
                    ? Object.values(
                          this.multiStepFormService.stepData
                              .get(this.modalInputData.modalId)
                              .get(3)
                      )
                    : [];
            const countOfUsers = this.multiStepFormService.stepData
                .get(this.modalInputData.modalId)
                .get(3)
                ? Object.values(
                      this.multiStepFormService.stepData
                          .get(this.modalInputData.modalId)
                          .get(3)
                  ).length
                : 0;
            if (countOfUsers > 0) {
                const obj = {};
                for (let i = 0; i < countOfUsers; i++) {
                    const userName = Object.keys(
                        this.multiStepFormService.stepData
                            .get(this.modalInputData.modalId)
                            .get(3)
                    )[i];
                    const values = widgetsSelected.filter((val) => {
                        if (
                            userNameWithWidgetsIds[i]?.length &&
                            userNameWithWidgetsIds[i]?.includes(val) &&
                            userName.trim() !== currentUser.trim()
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    if (values && values?.length) {
                        obj[userName] = values;
                    }
                }
                const set = new Set([].concat(...Object.values(obj)));
                const widgetsSelectedByCurrentUser = widgetsSelected?.filter(
                    (value) => !set.has(value)
                );
                if (
                    widgetsSelectedByCurrentUser &&
                    widgetsSelectedByCurrentUser.length
                ) {
                    obj[currentUser] = widgetsSelectedByCurrentUser;
                }
                reportInput['userNameWithWidgetsIds'] = obj;
            } else {
                const currentUser = `${this.userDataCache.firstName} ${
                    this.userDataCache.lastName
                        ? this.userDataCache.lastName
                        : ''
                }`.trim();
                reportInput['userNameWithWidgetsIds'] = {
                    [currentUser]: this.multiStepFormService.stepData
                        .get(this.modalInputData.modalId)
                        .get(1)['widgetsSelected'],
                };
            }
            reportInput['userReportWithAccessControl'] = this.modalInputData
                .data?.stepData?.userReportWithAccessControl
                ? this.modalInputData.data?.stepData
                      ?.userReportWithAccessControl
                : null;
        }
        return reportInput;
    }
}

enum Tab {
    DOWNLOAD_AND_MESSAGING = 'Download & Messaging',
    SAVE_AND_SCHEDULE = 'Save & Schedule'
}

interface RequestInput {
    sendingMechanism: {
        sendViaEmail: boolean;
    };
    reportTimespan: any;
    dayOfWeek: any;
    billingDay: any;
    // Adding Other Parameters for the Manthan Reports.
    timeLowerRange?: any;
    timeUpperRange?: any;
    timeRange?: any;
    selectedTimeZone?: any;
}
